<bp-calendly [options]="calendlyOptions"></bp-calendly>

<button *bpDelayedRender="200" @fadeIn type="button" mat-icon-button class="btn-close" mat-dialog-close>
	<mat-icon>close</mat-icon>
</button>
